import { FC, ReactElement, memo, useState } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { HostingsSearchingForm, useGetAllHostingsQuery } from '@/modules/Hostings';

import { HostingsListView } from './HostingsListView';

export const HostingsListContainer: FC = memo(() => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    data: hostingsListData,
    error: hostingsListError,
    isLoading: isHostingsListLoading,
    isFetching: isHostingsListFetching,
    isError: isHostingsListError
  } = useGetAllHostingsQuery({ page: currentPage }, search)();

  return (
    <FallbackedLayout
      isLoading={ isHostingsListLoading }
      error={ hostingsListError }
      isError={ isHostingsListError }
      data={ hostingsListData }
    >
      { (hostingsList): ReactElement => (
        <>
          <HostingsSearchingForm search={ search } handleSubmitSearch={ setSearch }/>
          <HostingsListView
            currentPage={ currentPage }
            hostingsListItems={ hostingsList.items }
            hostingsListTotalItems={ hostingsList.meta.totalItems }
            hostingsListItemsPerPage={ hostingsList.meta.itemsPerPage }
            isLoading={ isHostingsListFetching }
            handleChangePage={ handleChangePage }
          />
        </>
      ) }
    </FallbackedLayout>
  );
});
